import React, { useState } from 'react';
import { message, Spin } from 'antd';
import { CourseArchiveIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { Visible } from 'components';

import { useSaveCourse } from '../hooks';

interface IProps {
  isSaved: boolean;
  courseId: number;
  iconClass?: string;
}

export const SaveCourse: React.FC<IProps> = ({ isSaved, courseId, iconClass }) => {
  const t = useTranslations();
  const [saved, setSaved] = useState(isSaved);
  const { mutate, isLoading } = useSaveCourse();
  const isAuth = useAppSelector(({ user }) => user?.phone);

  const onSaveToggle = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();

    if (isLoading) return;

    if (!isAuth) {
      message.info(`${t('kurslarni_saqlab_olish_uchun_royxatdan_oting')}`);
      return;
    }

    mutate(
      { teacherCourseId: courseId, action: saved ? 'remove' : 'add' },
      {
        onSuccess: () => {
          setSaved(!saved);
        }
      }
    );
  };

  return (
    <div>
      <div onClick={onSaveToggle}>
        <Visible
          if={isLoading}
          else={
            <Visible
              if={saved}
              else={
                <span className="text-gray-400">
                  <CourseArchiveIcon className={iconClass} />
                </span>
              }
            >
              <span className="text-orange-500">
                <CourseArchiveIcon className={iconClass} />
              </span>
            </Visible>
          }
        >
          <Spin size="small" />
        </Visible>
      </div>
    </div>
  );
};
